import Vue from 'vue'
import directive from 'vue-common-laboratory/dist/utils/directive'

directive(Vue)



// WEBPACK FOOTER //
// ./src/utils/directive.js